module.exports = __webpack_public_path__ + "img/banner01.497c8f83.jpg";